import { ComponentInstance } from "@uniformdev/canvas";

import { SideNav } from "@/libraries/design/patterns";
import { SideNavProps } from "@/libraries/design/patterns/side-nav/src/side-nav";

import { transformNavItemData } from "../../side-nav-link/src/transform-nav-item-data";

export interface UniformSideNavProps {
    component: ComponentInstance;
}

const UniformSideNav = ({ component }: UniformSideNavProps) => {
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;

    const sideNavItems = transformNavItemData(slotItems);
    const props: SideNavProps = {
        title: component.parameters?.["title"]?.value as string,
        sideNavItems: sideNavItems
    };

    return <SideNav {...props} />;
};

export default UniformSideNav;
